import { render, staticRenderFns } from "./PropostaEdit.vue?vue&type=template&id=428901c4"
import script from "./PropostaEdit.vue?vue&type=script&lang=js"
export * from "./PropostaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports